let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g977S")).then(() => parcelRequire('bWQDL'));